import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import ContentLikeness from './ContentLikeness';
import ContentTags from './ContentTags';
const SlideSearchContent = (props) => {
    const { canUpdateTag, categories, changeFalseKeyControl, changeTrueKeyControl, images, list, loading, onChangeSelectSlide, onSubmitUpdateTag, page, selectMap, title, unit, } = props;
    return (_jsxs("div", Object.assign({ className: 'page_content' }, { children: [_jsx("h2", Object.assign({ className: 'content_title' }, { children: title })), _jsx(ContentTags, { canUpdateTag: canUpdateTag, categoryTags: categories, changeFalseKeyControl: changeFalseKeyControl, changeTrueKeyControl: changeTrueKeyControl, id: page.id, imageTags: images, onSubmit: onSubmitUpdateTag, slideId: page.slideId, tags: page.tags }, page.id), _jsx(ContentLikeness, { list: list, loading: loading, onChange: onChangeSelectSlide, selectMap: selectMap, unit: unit })] })));
};
SlideSearchContent.propTypes = {
    canUpdateTag: propBool().isRequired,
    categories: propArrayShape().isRequired,
    changeFalseKeyControl: propFunc().isRequired,
    changeTrueKeyControl: propFunc().isRequired,
    images: propArrayShape().isRequired,
    list: propArrayShape().isRequired,
    loading: propBool().isRequired,
    onChangeSelectSlide: propFunc().isRequired,
    onSubmitUpdateTag: propFunc().isRequired,
    page: propShape().isRequired,
    selectMap: propShape().isRequired,
    title: propStr().isRequired,
    unit: propShape().isRequired,
};
export default SlideSearchContent;
